/**
 * @generated SignedSource<<b4e6fdfd2cb15e9aefca9f120ff0a5b5>>
 * @relayHash d8c6996056289dd1af9b7a4881e29284
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd9739500a7cb7d558a70beaef0d095bc7345593dbb74847c1fd54be12d0506f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_EditionAwarenessTrialModalQuery } from './main_EditionAwarenessTrialModalQuery.graphql';

const node: PreloadableConcreteRequest<main_EditionAwarenessTrialModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cd9739500a7cb7d558a70beaef0d095bc7345593dbb74847c1fd54be12d0506f",
    "metadata": {},
    "name": "main_EditionAwarenessTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
